import Vue from 'vue'

/**
 * @author Jorge Nuñez López <>
 *
 * Get change history of warehouse
 * @return {Object}
 */

function transformer(data) {
  return {
    user: data.user,
    entryDate: data.add_date,
    movementType: data.warehouse_movement ? data.warehouse_movement.movement_type : null,
    comments: data.warehouse_movement ? data.warehouse_movement.comments : data.comments,
    warehouseMovementDate: data.warehouse_movement ? data.warehouse_movement.add_date : null,
    purchaseRequisition: data.warehouse_movement ?
      data.warehouse_movement.purchase_requisition :
      null,
  }
}

export default (warehouseId) =>
  Vue.$http.get(`purchase/warehouse/${warehouseId}/binnacle/`)
  .then(({ data }) => {
    const binnacleEntries = data.map(entry => transformer(entry))
    return binnacleEntries
  })


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/fetchBinnacle.js